// extracted by mini-css-extract-plugin
export default {"root":"index__root--bVnyV","close":"index__close--dySKk","view":"index__view--xSAdy"};